import { render, staticRenderFns } from "./CostItemHistory.vue?vue&type=template&id=06150d04"
import script from "./CostItemHistory.vue?vue&type=script&lang=js"
export * from "./CostItemHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports